import * as React from "react";
import { useState } from "react";
import { useCookies } from "react-cookie";
import { ButtonSection, ListItem, ListSection, Wrapper } from "./styles";
import { StyledButton } from "../generic";
import { Checkbox } from "../CheckRadiobox";
import { useTranslation } from "react-i18next";

export const CookieBanner = () => {
  const { t, i18n } = useTranslation("cookies");
  const [cookies, setCookie] = useCookies([
    "personalised",
    "marketing",
    "accepted"
  ]);
  const [cookiesState, setCookiesState] = useState({
    essential: true,
    personalised: true,
    marketing: true
  });

  const [open, setOpen] = useState<boolean>(!cookies.accepted);
  const [bannerOptions, setBannerOptions] = useState<boolean>(false);

  const setCookieHandler = () => {
    setCookie("personalised", cookiesState["personalised"]);
    setCookie("marketing", cookiesState["marketing"]);
    setCookie("accepted", "true");
    setOpen(false);
  };

  const selectedItem = (item: boolean, title: string) => {
    return {
      title: title,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
        setCookiesState((prev) => ({
          ...prev,
          [e.target.name]: !prev[e.target.name as keyof typeof cookiesState]
        }));
      },
      checked: item,
      p: "0"
    };
  };

  return (
    <Wrapper open={open}>
      {bannerOptions ? (
        <>
          <ListSection>
            <ListItem>
              <Checkbox
                key={"essential"}
                name={"essential"}
                disabled={true}
                {...selectedItem(
                  cookiesState["essential" as keyof typeof cookiesState],
                  t("cookieBanner.title1")
                )}
                p="0 8px 0 0"
              />
              <p>{t("cookieBanner.desc1")}</p>
            </ListItem>
            <ListItem>
              <Checkbox
                key={"personalised"}
                name={"personalised"}
                {...selectedItem(
                  cookiesState["personalised" as keyof typeof cookiesState],
                  t("cookieBanner.title2")
                )}
                p="0 8px 0 0"
              />
              <p>{t("cookieBanner.desc2")}</p>
            </ListItem>
            <ListItem>
              <Checkbox
                key={"marketing"}
                name={"marketing"}
                {...selectedItem(
                  cookiesState["marketing" as keyof typeof cookiesState],
                  t("cookieBanner.title3")
                )}
                p="0 8px 0 0"
              />
              <p>{t("cookieBanner.desc3")}</p>
            </ListItem>
          </ListSection>
          <ButtonSection>
            <StyledButton outline onClick={() => setBannerOptions(false)}>
              {t("cookieBanner.back")}
            </StyledButton>
            <StyledButton onClick={setCookieHandler}>
              {t("cookieBanner.agree")}
            </StyledButton>
          </ButtonSection>
        </>
      ) : (
        <>
          <a href={`/${i18n.language}/cookies`} target="_blank">
            {t("cookieBanner.text.p1")} <b>{t("cookieBanner.text.p2")}</b>
          </a>
          <ButtonSection>
            <StyledButton outline onClick={() => setBannerOptions(true)}>
              {t("cookieBanner.settings")}
            </StyledButton>
            <StyledButton onClick={setCookieHandler}>
              {t("cookieBanner.agree")}
            </StyledButton>
          </ButtonSection>
        </>
      )}
    </Wrapper>
  );
};
